/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Push: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929L20.5858 12L16.2929 7.70711C15.9024 7.31658 15.9024 6.68342 16.2929 6.29289Z'
      fill='currentColor'
    />
  </React.Fragment>
)
